export default __webpack_public_path__ + "934843a19247ba5d95e5f81f96fd2f3d.png";